import React, { Component, PropTypes } from 'react';

const AuteurLiensTable = ({liens, loading, error, handleEdit,loginok}) => {

	if (loading){
		return (
			<div className="center-block loader"></div>
		);
	}

	if (error){
		return (
			<div className="alert alert-danger">{error}</div>
		);
	}
	
	if (! liens || liens.length == 0){
		return (
			<div>Pas encore de liens</div>
		);
	}
	return(
		<div className="panel panel-default">
		<div className="panel-body">
			<ul>
				{liens.map((el,idx)=>{
					return (
						<li key={idx} >
							<a href={el.href} target="_BLANK">{el.ltitle}</a>, proposé par {el.pseudo} le {el.ldate}
							<br/>
							{el.ldesc}
							<br/>
							{loginok == 1 && (
								<button className="btn btn-link" style={{'paddingLeft': 0}} onClick={handleEdit.bind(null,el.id)}>Editer</button>
								)
							}
							{(idx < liens.length-1) && (<hr/>)}
							
						</li>
					)
					})
				}
			</ul>
		</div>
		</div>
	);
}

AuteurLiensTable.propTypes = {
	'loading' : PropTypes.bool.isRequired,
	'error' : PropTypes.string,
	'liens' : PropTypes.arrayOf(PropTypes.shape(
	{
		'href' : PropTypes.string.isRequired,
		'id' : PropTypes.number.isRequired,
		'ldate' : PropTypes.string,
		'ltitle' : PropTypes.string,
		'ldesc' : PropTypes.string,
		'nom' : PropTypes.string,
		'prenom' : PropTypes.string,
		'pseudo' : PropTypes.string,
		'uid' : PropTypes.string
	})),
	'handleEdit': PropTypes.func.isRequired
}

export default AuteurLiensTable


// WEBPACK FOOTER //
// ./auteur/liens/AuteurLiensTable.jsx